<template>
    <div class="wrap-dropdown">
        <button type="button" class="btn" ref="button" id="button" @click="showPopup = !showPopup"><slot name="buttonDropdown"></slot></button>
        <div
            class="dropdown"
            v-show="showPopup"
            :style="positionCss"
            v-closable="{
                exclude: ['button'],
                handler: 'onClose',
            }"
        >
            <slot name="menuDropdown"> Dropdown Opened </slot>
        </div>
    </div>
</template>

<script>
let handleOutsideClick;
import Vue from "vue";
Vue.directive("closable", {
    bind(el, binding, vnode) {
        handleOutsideClick = (event) => {
            event.stopPropagation();
            const { handler, exclude } = binding.value;
            let clickedOnExcludedEl = false;
            exclude.forEach((refName) => {
                if (!clickedOnExcludedEl) {
                    const excludeEl = vnode.context.$refs[refName];
                    if (excludeEl) {
                        clickedOnExcludedEl = excludeEl.contains(event.target);
                    }
                }
            });
            if (!el.contains(event.target) && !clickedOnExcludedEl) {
                vnode.context[handler]();
            }
        };
        document.addEventListener("click", handleOutsideClick);
        document.addEventListener("touchstart", handleOutsideClick);
    },
    unbind() {
        document.removeEventListener("click", handleOutsideClick);
        document.removeEventListener("touchstart", handleOutsideClick);
    },
});
export default {
    // directives: {
    //   closable: {
    //     bind(el, binding, vnode) {
    //       handleOutsideClick = (event) => {
    //         event.stopPropagation();
    //         const { handler, exclude } = binding.value;
    //         let clickedOnExcludedEl = false;
    //         exclude.forEach((refName) => {
    //           if (!clickedOnExcludedEl) {
    //             const excludeEl = vnode.ctx.ctx.$refs[refName];
    //             if (excludeEl) {
    //               clickedOnExcludedEl = excludeEl.contains(event.target);
    //             }
    //           }
    //         });
    //         if (!el.contains(event.target) && !clickedOnExcludedEl) {
    //           vnode.ctx.ctx[handler]();
    //         }
    //       };
    //       document.addEventListener("click", handleOutsideClick);
    //       document.addEventListener("touchstart", handleOutsideClick);
    //     },
    //     unbind() {
    //       document.removeEventListener("click", handleOutsideClick);
    //       document.removeEventListener("touchstart", handleOutsideClick);
    //     },
    //   },
    // },
    props: {
        position: {
            type: String,
        },
    },
    data() {
        return {
            showPopup: false,
        };
    },

    computed: {
        positionCss() {
            let style = "";
            if (this.position == "right") {
                style = "right : 0";
            }

            return style;
        },
    },

    methods: {
        onClose() {
            this.showPopup = false;
        },
    },
};
</script>

<style scoped>
.wrap-dropdown {
    position: relative;
}
.btn-primer {
    padding: unset;
    background: transparent;
    font-size: 13px;
}

.dropdown {
    background: #ffffff;
    box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    text-align: left;
    position: absolute;
    top: 2.5rem;
    min-width: 10rem;
    z-index: 1;
}
</style>
